import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { store } from './store/store';
import { ThemeProvider } from './theme/ThemeContext';
import ThemeToaster from './components/theme/ThemeToaster';
import './styles/index.css';

// Enforce India timezone for all locale-based date/time rendering.
const APP_TIMEZONE = 'Asia/Kolkata';
const originalToLocaleDateString = Date.prototype.toLocaleDateString;
const originalToLocaleTimeString = Date.prototype.toLocaleTimeString;
const originalToLocaleString = Date.prototype.toLocaleString;

Date.prototype.toLocaleDateString = function toLocaleDateStringWithTimezone(locales, options) {
  return originalToLocaleDateString.call(this, locales, {
    ...options,
    timeZone: options?.timeZone || APP_TIMEZONE,
  });
};

Date.prototype.toLocaleTimeString = function toLocaleTimeStringWithTimezone(locales, options) {
  return originalToLocaleTimeString.call(this, locales, {
    ...options,
    timeZone: options?.timeZone || APP_TIMEZONE,
  });
};

Date.prototype.toLocaleString = function toLocaleStringWithTimezone(locales, options) {
  return originalToLocaleString.call(this, locales, {
    ...options,
    timeZone: options?.timeZone || APP_TIMEZONE,
  });
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider>
            <App />
            <ThemeToaster />
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
